import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findRefundableOrder({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`onlineOrder/findRefundableOrder`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getRefundableOrderById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`onlineOrder/findOnlineRefundById`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	findRefundOrder({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/onlineOrder/findOnlineRefundOrder`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	save({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/onlineOrder/saveOnlineRefundOrder`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	submit({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/onlineOrder/saveOnlineRefundOrder`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	deleteById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/onlineOrder/refundOrderDelete`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	approve({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`onlineOrder/approveOnlineRefundStart`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
  },
}